{
  "enums": {
    "claimStatus": {
      "draft": "வரைவு",
      "submitted": "சமர்ப்பிக்கப்பட்டது",
      "accepted": "ஏற்கப்பட்டது",
      "denied": "மறுக்கப்பட்டது",
      "paid": "செலுத்தப்பட்டது"
    },
    "chargeStatus": {
      "pending": "நிலுவையில்",
      "unbilled": "பில் செய்யப்படவில்லை",
      "posted": "பதிவு செய்யப்பட்டது",
      "billed": "பில் செய்யப்பட்டது",
      "adjusted": "சரிசெய்யப்பட்டது",
      "voided": "ரத்து செய்யப்பட்டது"
    },
    "statementDelivery": {
      "print": "அச்சிடு",
      "email": "மின்னஞ்சல்",
      "both": "அச்சு மற்றும் மின்னஞ்சல்",
      "mail": "அஞ்சல்"
    },
    "statementStatus": {
      "generated": "உருவாக்கப்பட்டது",
      "sent": "அனுப்பப்பட்டது",
      "viewed": "பார்க்கப்பட்டது"
    },
    "denialStatus": {
      "new": "புதிய",
      "inReview": "மறுஆய்வில்",
      "appealing": "மேல்முறையீட்டில்",
      "resolved": "தீர்க்கப்பட்டது",
      "writtenOff": "கடன் தள்ளுபடி செய்யப்பட்டது"
    },
    "denialPriority": {
      "low": "குறைவு",
      "medium": "நடுத்தரம்",
      "high": "உயர்வு"
    },
    "claimType": {
      "professional": "தொழில்முறை",
      "institutional": "நிறுவன",
      "dental": "பல்",
      "pharmacy": "மருந்தகம்"
    },
    "paymentMethod": {
      "cash": "பணம்",
      "check": "காசோலை",
      "creditCard": "கடன் அட்டை",
      "debitCard": "பற்று அட்டை",
      "bankTransfer": "வங்கி பரிமாற்றம்",
      "digitalWallet": "டிஜிட்டல் பணப்பை",
      "insurance": "காப்பீடு"
    },
    "paymentSource": {
      "patient": "நோயாளி",
      "insurance": "காப்பீடு",
      "thirdParty": "மூன்றாம் தரப்பு"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "நோயாளர் ஐடி தேவை",
      "encounterIdRequired": "சந்திப்பு ஐடி தேவை",
      "payerIdRequired": "செலுத்துநர் ஐடி தேவை",
      "chargeCodeRequired": "கட்டண குறியீடு தேவை",
      "unitPriceRequired": "அலகு விலை தேவை",
      "amountRequired": "தொகை தேவை",
      "amountPositive": "தொகை பூஜ்ஜியத்தை விட அதிகமாக இருக்க வேண்டும்",
      "chargeSelectionRequired": "குறைந்தது ஒரு கட்டணத்தையாவது தேர்ந்தெடுக்கவும்"
    }
  },
  "pages": {
    "statements": {
      "title": "பில்லிங் அறிக்கைகள்",
      "labels": {
        "dashboard": "டாஷ்போர்டு",
        "patient": "நோயாளி",
        "from": "இருந்து",
        "to": "வரை",
        "batchGenerate": "தொகுப்பாக உருவாக்கு",
        "previewStatement": "அறிக்கை முன்னோட்டம்",
        "generatePrint": "உருவாக்கி அச்சிடு",
        "generateEmail": "உருவாக்கி மின்னஞ்சல் அனுப்பு",
        "printEmail": "அச்சு மற்றும் மின்னஞ்சல்",
        "print": "அச்சிடு",
        "email": "மின்னஞ்சல்"
      },
      "placeholders": {
        "searchPatient": "பெயர் அல்லது MRN மூலம் தேடு..."
      },
      "aria": {
        "periodFrom": "அறிக்கை காலம் இருந்து",
        "periodTo": "அறிக்கை காலம் வரை"
      },
      "table": {
        "header": {
          "statementHistory": "அறிக்கை வரலாறு",
          "patient": "நோயாளி",
          "mrn": "MRN",
          "date": "தேதி",
          "amount": "தொகை",
          "delivery": "வழங்கல்",
          "status": "நிலை"
        },
        "preview": {
          "modal": "அறிக்கை முன்னோட்டம்",
          "patientStatement": "நோயாளி அறிக்கை",
          "patient": "நோயாளி:",
          "mrn": "MRN:",
          "statementDate": "அறிக்கை தேதி:",
          "period": "காலம்:",
          "lineItemHeader": {
            "date": "தேதி",
            "description": "விளக்கம்",
            "charges": "கட்டணங்கள்",
            "payments": "கட்டணங்கள் செலுத்தல்",
            "balance": "மீதி"
          },
          "openingBalance": "தொடக்க மீதி",
          "totals": "மொத்தம்",
          "amountDue": "செலுத்த வேண்டிய தொகை"
        }
      },
      "states": {
        "generating": "உருவாக்குகிறது...",
        "loading": "முன்னோட்டத்தை உருவாக்குகிறது...",
        "noPatients": "நோயாளிகள் இல்லை",
        "noStatementData": "அறிக்கை தரவு இல்லை",
        "loadingHistory": "வரலாற்றை ஏற்றுகிறது...",
        "noStatementsGenerated": "இன்னும் அறிக்கைகள் உருவாக்கப்படவில்லை",
        "selectedPatientId": "தேர்ந்தெடுக்கப்பட்ட நோயாளி ID: {{id}}"
      },
      "toast": {
        "generated": "அறிக்கை உருவாக்கப்பட்டது",
        "generatedError": "அறிக்கையை உருவாக்க முடியவில்லை",
        "batchStarted": "தொகுப்பு உருவாக்கம் தொடங்கியது: {{count}} அறிக்கைகள் வரிசையில் உள்ளன",
        "batchError": "தொகுப்பு உருவாக்கத்தைத் தொடங்க முடியவில்லை"
      }
    },
    "claims": {
      "title": "உரிமைகோரல் மேலாண்மை",
      "labels": {
        "dashboard": "டாஷ்போர்டு",
        "createClaim": "உரிமைகோரல் உருவாக்கு",
        "filters": "வடிப்பான்கள்",
        "submit": "சமர்ப்பி",
        "appeal": "மேல்முறையீடு",
        "denialReason": "மறுப்பு காரணம்",
        "expandHint": "பிரத்யேக உரிமைகோரல் பக்கத்தில் வரி உருப்படிகளைப் பார்க்க உரிமைகோரலை விரிவாக்கவும்.",
        "cancel": "ரத்து"
      },
      "filter": {
        "allStatuses": "அனைத்து நிலைகள்"
      },
      "placeholders": {
        "filterPayer": "செலுத்துநரால் வடிகட்டு..."
      },
      "aria": {
        "claimDateFrom": "உரிமைகோரல் தேதி முதல்",
        "claimDateTo": "உரிமைகோரல் தேதி வரை"
      },
      "table": {
        "header": {
          "claimNumber": "உரிமைகோரல் #",
          "patient": "நோயாளி",
          "payer": "செலுத்துநர்",
          "total": "மொத்தம்",
          "status": "நிலை",
          "submitted": "சமர்ப்பிக்கப்பட்டது",
          "actions": "செயல்கள்"
        }
      },
      "modal": {
        "createClaim": "கட்டணங்களிலிருந்து உரிமைகோரல் உருவாக்கு",
        "patientId": "நோயாளி ID *",
        "payerId": "செலுத்துநர் ID *",
        "selectCharges": "கட்டணங்களைத் தேர்ந்தெடுக்கவும் ({{selected}} தேர்ந்தெடுக்கப்பட்டது)",
        "noBilledCharges": "இந்த நோயாளிக்கு பில் செய்யப்படாத கட்டணங்கள் இல்லை"
      },
      "states": {
        "loading": "உரிமைகோரல்கள் ஏற்றப்படுகிறது...",
        "noClaims": "உரிமைகோரல்கள் எதுவும் இல்லை",
        "creating": "உருவாக்குகிறது..."
      },
      "toast": {
        "created": "உரிமைகோரல் உருவாக்கப்பட்டது",
        "createdError": "உரிமைகோரலை உருவாக்க முடியவில்லை",
        "submitted": "உரிமைகோரல் சமர்ப்பிக்கப்பட்டது",
        "submittedError": "உரிமைகோரலை சமர்ப்பிக்க முடியவில்லை",
        "resubmitted": "மேல்முறையீட்டுக்காக உரிமைகோரல் மீண்டும் சமர்ப்பிக்கப்பட்டது",
        "resubmittedError": "உரிமைகோரலை மீண்டும் சமர்ப்பிக்க முடியவில்லை",
        "patientPayerRequired": "நோயாளி மற்றும் செலுத்துநர் தேவை",
        "chargeRequired": "குறைந்தது ஒரு கட்டணத்தைத் தேர்ந்தெடுக்கவும்"
      }
    },
    "charges": {
      "title": "கட்டண மேலாண்மை",
      "labels": {
        "dashboard": "டாஷ்போர்டு",
        "newCharge": "புதிய கட்டணம்",
        "totalChargesPeriod": "மொத்த கட்டணங்கள் (காலம்)",
        "filters": "வடிப்பான்கள்",
        "cancel": "ரத்து"
      },
      "filter": {
        "allStatuses": "அனைத்து நிலைகள்"
      },
      "placeholders": {
        "filterPatient": "நோயாளி மூலம் வடிகட்டு..."
      },
      "aria": {
        "serviceDateFrom": "சேவை தேதி முதல்",
        "serviceDateTo": "சேவை தேதி வரை"
      },
      "table": {
        "header": {
          "date": "தேதி",
          "patient": "நோயாளி",
          "encounter": "சந்திப்பு",
          "code": "குறியீடு",
          "description": "விளக்கம்",
          "qty": "அளவு",
          "unitPrice": "அலகு விலை",
          "total": "மொத்தம்",
          "status": "நிலை",
          "actions": "செயல்கள்"
        }
      },
      "actions": {
        "void": "ரத்து"
      },
      "modal": {
        "voidCharge": "கட்டணத்தை ரத்து செய்",
        "voidChargeConfirm": "கட்டணம் {{code}} - {{description}} ({{amount}}) ஐ ரத்து செய்யவா?",
        "reason": "காரணம் *",
        "reasonPlaceholder": "ரத்து செய்வதற்கான காரணத்தை உள்ளிடவும்..."
      },
      "states": {
        "loading": "கட்டணங்கள் ஏற்றப்படுகிறது...",
        "noCharges": "இந்தக் காலத்திற்கு கட்டணங்கள் எதுவும் இல்லை",
        "voiding": "ரத்து செய்யப்படுகிறது..."
      },
      "toast": {
        "voided": "கட்டணம் ரத்து செய்யப்பட்டது",
        "voidedError": "கட்டணத்தை ரத்து செய்ய முடியவில்லை",
        "reasonRequired": "காரணம் தேவை"
      }
    },
    "payments": {
      "title": "கட்டணப் பதிவு",
      "labels": {
        "dashboard": "டாஷ்போர்டு",
        "uploadEraEob": "ERA/EOB பதிவேற்று",
        "postPayment": "கட்டணம் பதிவு செய்",
        "totalPaymentsPeriod": "மொத்தக் கட்டணங்கள் (காலம்)",
        "filters": "வடிப்பான்கள்",
        "cancel": "ரத்து"
      },
      "placeholders": {
        "filterPatient": "நோயாளி மூலம் வடிகட்டு..."
      },
      "aria": {
        "paymentDateFrom": "கட்டணத் தேதி (முதல்)",
        "paymentDateTo": "கட்டணத் தேதி (வரை)"
      },
      "table": {
        "header": {
          "date": "தேதி",
          "patient": "நோயாளி",
          "claimNumber": "உரிமைகோரல் #",
          "amount": "தொகை",
          "method": "முறை",
          "reference": "குறிப்பு",
          "postedBy": "பதிவு செய்தவர்"
        }
      },
      "modal": {
        "postPayment": "கட்டணம் பதிவு செய்",
        "patientId": "நோயாளி ஐடி *",
        "claimId": "உரிமைகோரல் ஐடி (விருப்பத்தேர்வு)",
        "claimIdHint": "பயன்படுத்தப்படாத கட்டணத்திற்கு காலியாக விடவும்",
        "amount": "தொகை *",
        "method": "முறை *",
        "referenceNumber": "குறிப்பு எண்",
        "referenceHint": "காசோலை எண், பரிவர்த்தனை ஐடி, முதலியன",
        "notes": "குறிப்புகள்"
      },
      "states": {
        "loading": "கட்டணங்கள் ஏற்றப்படுகிறது...",
        "noPayments": "இந்தக் காலத்திற்கு கட்டணங்கள் எதுவும் இல்லை",
        "posting": "பதிவு செய்யப்படுகிறது..."
      },
      "toast": {
        "posted": "கட்டணம் வெற்றிகரமாக பதிவு செய்யப்பட்டது",
        "postedError": "கட்டணத்தைப் பதிவு செய்ய முடியவில்லை",
        "patientAmountRequired": "நோயாளி மற்றும் தொகை தேவை",
        "validAmount": "சரியான தொகையை உள்ளிடவும்",
        "eraEobSoon": "ERA/EOB பதிவேற்றம் விரைவில் வரும்"
      }
    },
    "chargeForm": {
      "title": "கட்டணத்தை உருவாக்கு",
      "labels": {
        "patientId": "நோயாளி ஐடி *",
        "encounterId": "சந்திப்பு ஐடி *",
        "chargeCode": "கட்டண குறியீடு *",
        "description": "விளக்கம்",
        "cptCode": "CPT குறியீடு",
        "quantity": "அளவு *",
        "unitPrice": "அலகு விலை *"
      },
      "placeholders": {
        "chargeCode": "கட்டண மாஸ்டரைத் தேடு...",
        "cptCode": "CPT செயல்முறை குறியீட்டைத் தேடு..."
      },
      "buttons": {
        "cancel": "ரத்து",
        "create": "கட்டணத்தை உருவாக்கு"
      },
      "toast": {
        "created": "கட்டணம் உருவாக்கப்பட்டது",
        "createdError": "கட்டணத்தை உருவாக்கத் தவறிவிட்டது"
      }
    },
    "claimForm": {
      "title": "உரிமைகோரல் உருவாக்கு",
      "labels": {
        "patientId": "நோயாளி ID *",
        "encounterId": "சந்திப்பு ஐடி *",
        "payerId": "செலுத்துநர் ID *",
        "claimType": "உரிமைகோரல் வகை *",
        "diagnosisCodes": "நோயறிதல் குறியீடுகள்",
        "selectCharges": "கட்டணங்களைத் தேர்ந்தெடுக்கவும் ({{selected}} தேர்ந்தெடுக்கப்பட்டது)",
        "notes": "குறிப்புகள்"
      },
      "placeholders": {
        "diagnosisCodes": "காற்புள்ளியால் பிரிக்கப்பட்ட ICD-10 குறியீடுகள் (எ.கா. J06.9, R05)"
      },
      "buttons": {
        "cancel": "ரத்து",
        "create": "உரிமைகோரல் உருவாக்கு"
      },
      "toast": {
        "created": "உரிமைகோரல் உருவாக்கப்பட்டது",
        "createdError": "உரிமைகோரலை உருவாக்க முடியவில்லை"
      }
    },
    "paymentForm": {
      "title": "கட்டணம் பதிவு செய்",
      "labels": {
        "patientId": "நோயாளி ஐடி *",
        "claimId": "உரிமைகோரல் ஐடி",
        "amount": "தொகை *",
        "method": "கட்டண முறை *",
        "source": "மூலம்",
        "referenceNumber": "குறிப்பு எண்",
        "notes": "குறிப்புகள்"
      },
      "placeholders": {
        "claimId": "விருப்பத்தேர்வு — உரிமைகோரலுடன் இணை",
        "reference": "பரிவர்த்தனை அல்லது காசோலை குறிப்பு"
      },
      "buttons": {
        "cancel": "ரத்து",
        "post": "கட்டணம் பதிவு செய்"
      },
      "toast": {
        "recorded": "கட்டணம் பதிவு செய்யப்பட்டது",
        "recordedError": "கட்டணத்தைப் பதிவு செய்வதில் தோல்வி"
      }
    },
    "denials": {
      "title": "மறுப்பு மேலாண்மை",
      "subtitle": "பில்லிங் உரிமைகோரல் மறுப்புகளைக் கண்காணித்து நிர்வகிக்கவும்",
      "placeholders": {
        "search": "உரிமைகோரல்களைத் தேடு..."
      },
      "filter": {
        "all": "அனைத்தும்"
      },
      "checkbox": {
        "assignedToMe": "எனக்கு ஒதுக்கப்பட்டது"
      },
      "table": {
        "header": {
          "claimNumber": "உரிமைகோரல் எண்",
          "patient": "நோயாளி",
          "denialCode": "மறுப்பு குறியீடு",
          "denialReason": "மறுப்பு காரணம்",
          "amount": "தொகை",
          "daysRemaining": "மீதமுள்ள நாட்கள்",
          "status": "நிலை",
          "assignedTo": "ஒதுக்கப்பட்டவர்",
          "actions": "செயல்கள்"
        }
      },
      "actions": {
        "review": "மதிப்பாய்வு",
        "appeal": "மேல்முறையீடு",
        "writeOff": "கடன் தள்ளுபடி",
        "cancel": "ரத்து"
      },
      "modal": {
        "appealReason": "மேல்முறையீட்டு காரணம்",
        "appealPlaceholder": "மேல்முறையீட்டுக்கான காரணத்தை விவரிக்கவும்...",
        "submitAppeal": "மேல்முறையீட்டைச் சமர்ப்பி",
        "writeOffTitle": "மறுப்பைக் கடன் தள்ளுபடி செய்",
        "writeOffConfirm": "உரிமைகோரல் {{claimNumber}} ஐ {{amount}} க்கு கடன் தள்ளுபடி செய்ய விரும்புகிறீர்களா? இந்தச் செயலை மீட்டெடுக்க முடியாது.",
        "writeOffButton": "கடன் தள்ளுபடி"
      },
      "states": {
        "loading": "மறுப்புகள் ஏற்றப்படுகின்றன...",
        "noDenials": "மறுப்புகள் எதுவும் இல்லை",
        "submitting": "சமர்ப்பிக்கிறது..."
      },
      "toast": {
        "updateError": "மறுப்பு நிலையைப் புதுப்பிக்க முடியவில்லை",
        "movedToReview": "உரிமைகோரல் {{claimNumber}} மதிப்பாய்வுக்கு நகர்த்தப்பட்டது",
        "appealSubmitted": "மேல்முறையீடு சமர்ப்பிக்கப்பட்டது",
        "writtenOff": "உரிமைகோரல் {{claimNumber}} கடன் தள்ளுபடி செய்யப்பட்டது"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
